import React from 'react';
import './Footer.css';
import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa'; // Import GitHub icon

const Footer = () => {
    return (
        <footer>
            <div className="footer-content">
                <p>&copy; 2024 My Blog. All rights reserved.</p>
                <div className="footer-socials">
                    <a href="https://www.linkedin.com/in/csy2001/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin className="social-icon" /> LinkedIn
                    </a>
                    <a href="https://www.instagram.com/yourprofile" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className="social-icon" /> Instagram
                    </a>
                    <a href="https://github.com/ycs2001" target="_blank" rel="noopener noreferrer">
                        <FaGithub className="social-icon" /> GitHub
                    </a>
                </div>
                <div className="footer-contact">
                    <p>Email: <a href="cyang017@uottawa.ca">cyang017@uottawa.ca</a></p>
                    <p>Phone: +249-875-1733</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
